<app-dialog
  #dialog
  [key]="'create-with-cog'"
  [action]="'create-with-cog'"
  [headerTheme]="'simple'"
  [title]="tk.General.CreateOperationsWithCogAi | t"
  [breakpoints]="{
    '960px': '400px',
    '768px': '70vw',
    '640px': '100vw',
    '480px': '100vw',
  }">
  <p-tabs [value]="0">
    <p-tablist>
      <p-tab value="0">{{ tk.General.FromText | t }}</p-tab>
      <p-tab value="1">{{ tk.General.StartFromImage | t }}</p-tab>
    </p-tablist>
    <p-tabpanels>
      <!-- Text Tab -->
      <p-tabpanel value="0">
        <app-select
          [allowEmptyPlaceholderSelect]="true"
          [label]="tk.Management.NdfBank | t"
          [options]="innerFinancialInstitutions"
          [(ngModel)]="selectedFinancialInstitution"
          [placeholder]="tk.User.Select | t">
          <ng-template let-item>
            <app-bank-logo [code]="item?.data?.compensationCode" />
            {{ item.label }}
          </ng-template>
        </app-select>

        <div class="cog-prompt">
          <app-input
            type="textarea"
            label="Texto das operações"
            placeholder="Cole aqui o e-mail, a tabela ou a mensagem do banco com as operações"
            [ngModel]="promptText"
            (ngModelChange)="onPromptTextChange($event)" />
        </div>
      </p-tabpanel>
      <!-- Image Tab -->
      <p-tabpanel value="1">
        <div
          class="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center"
          (dragover)="onDragOver($event)"
          (drop)="onDrop($event)"
          (paste)="onPaste($event)">
          <div *ngIf="!selectedImage" class="space-y-4">
            <i class="pi pi-image text-4xl text-gray-400"></i>
            <p class="text-gray-600">{{ tk.General.DragImageHereOrPasteFromClipboard | t }}</p>
            <p-fileUpload
              mode="basic"
              [chooseLabel]="tk.General.SelectImage | t"
              [auto]="true"
              accept="image/*"
              [maxFileSize]="10000000"
              (onSelect)="onFileSelect($event)"
              styleClass="p-button-secondary"></p-fileUpload>
          </div>

          <div *ngIf="selectedImage" class="relative">
            <img
              [src]="selectedImage"
              [alt]="tk.General.Preview | t"
              class="max-w-full max-h-96 mx-auto rounded"
              style="max-width: 100%" />
            <app-button icon="pi pi-times" (click)="removeImage()" />
          </div>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>

  <ng-template #footer>
    <div class="dialog__footer">
      <app-button
        [disabled]="!this.selectedFile && !promptText.trim()"
        [isLoading]="isLoading"
        [loadingText]="tk.General.ExtractingOperations | t"
        [label]="tk.General.ImportOperations | t"
        (sendButtonClick)="processOperationsWithCog()"></app-button>
    </div>
  </ng-template>
</app-dialog>
